export const environment = {
  production: true,
  hmr: false,
  frontendUrl:"https://anataleb.com",
  apiUrl:"https://backend.anataleb.com/api/v1",
  apiSocketUrl:"https://backend.anataleb.com/",
  apiDirectUrl:"https://backend.anataleb.com/",
  apiUploadUrl:"https://anataleb.s3.us-east-2.amazonaws.com/",
  stripe: {
    publicKey: 'pk_test_S1eEGdRF5Itmnfwk9rNHFZnV00YlGgdUtt',
  }
};